
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';

var script = {
  name: 'PendoActionsCell',
  components: {
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  props: {
    row: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      default: () => [{
        type: 'edit',
        icon: 'edit',
        tooltip: 'Edit'
      }, {
        type: 'duplicate',
        icon: 'copy',
        tooltip: 'Duplicate'
      }, {
        type: 'delete',
        icon: 'trash-2',
        tooltip: 'Delete'
      }]
    }
  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-table__actions"
  }, _vm._l(_vm.actions, function (action) {
    return _c('div', {
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip",
        value: {
          content: action.tooltip,
          arrow: true,
          multiline: true,
          delay: {
            show: 500,
            hide: 0
          }
        },
        expression: "{\n            content: action.tooltip,\n            arrow: true,\n            multiline: true,\n            delay: { show: 500, hide: 0 }\n        }"
      }],
      key: action.type
    }, [_c('pendo-button', {
      staticClass: "pendo-table__action",
      class: "pendo-table__action--" + action.type,
      attrs: {
        "size": "mini",
        "type": "secondary",
        "icon": action.icon,
        "disabled": action.disabled
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.$emit(action.type, _vm.row);
        }
      }
    })], 1);
  }), 0);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-actions-cell.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoActionsCell = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoActionsCell;
